export default __webpack_public_path__ + "static/media/avatar.f6865aec.png";